import React, { useCallback, useState } from 'react';
import Form from 'react-bootstrap/esm/Form';

import { usePokCore } from '../../../common/hooks/usePokCore';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import DictionarySelector from '../Selects/DictionarySelector';
import { OptionWithLang } from '../Selects/Selector';
import { useClientContactsModal } from '../Contacts/useClientContactsModal';
import { FormRow } from '../../../app/components/FormRow';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { ClientWithContactsSearch } from './ClientWithContactsSearch';

export const ClientWithoutContact: React.FC = () => {
  const pok = usePokCore();
  const { t, tk } = useTranslation('clientLng');
  const [contactTypeId, setContactTypeId] = useState<string>();
  const [refresh, setRefresh] = useState(false);
  const { open, modal } = useClientContactsModal(() => setRefresh(r => !r));

  const getData = useCallback(
    ((
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) =>
      pok.clients.getWithoutContactTypeByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        contactTypeId,
      )) as GridGetterFunction,
    [pok.clients, contactTypeId],
  );

  const getCount = useCallback(
    ((filterText: string, filterColumns: string) =>
      pok.clients.getWithoutContactTypeCount(
        filterText,
        filterColumns,
        contactTypeId,
      )) as GridCountFunction,
    [pok.clients, contactTypeId],
  );

  return (
    <>
      <Form className="d-grid gap-4 mb-3">
        <FormRow controlId="client" label={t(tk.client.contactType)}>
          <DictionarySelector
            dictionary="Typy kontaktów"
            value={contactTypeId}
            onChange={(option: OptionWithLang) =>
              setContactTypeId(option.value)
            }
            clearable
          />
        </FormRow>
      </Form>
      {contactTypeId && (
        <ClientWithContactsSearch
          getData={getData}
          getCount={getCount}
          onRowClick={open}
          refresh={refresh}
          hideContacts
        />
      )}
      {modal}
    </>
  );
};
